import { PhoneCall, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { PHONE_DISPLAY, PHONE_TEL, COMPANY } from "@/lib/site-content";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Utilities", href: "#utilities" },
  { label: "Why Us", href: "#why-us" },
  { label: "Request", href: "#request" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b transition-colors ${
        scrolled ? "border-zinc-200" : "border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        {/* Logo */}
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="w-9 h-9 bg-[#FF4500] flex items-center justify-center text-white font-black font-display text-lg group-hover:rotate-3 transition-transform">
            S
          </span>
          <span className="font-display font-black text-lg sm:text-xl tracking-tight text-zinc-900">
            {COMPANY.split(" ")[0]}
            <span className="text-zinc-400 font-normal"> Solutions</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-display text-sm font-semibold text-zinc-700 hover:text-[#FF4500] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* Phone CTA */}
        <div className="flex items-center gap-2">
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="hidden sm:inline-flex items-center gap-2 bg-[#FF4500] hover:bg-[#E63E00] text-white px-4 sm:px-5 py-3 font-display font-bold text-sm tracking-wide transition-all active:scale-[0.97]"
          >
            <PhoneCall className="w-4 h-4" strokeWidth={2.5} />
            <span>{PHONE_DISPLAY}</span>
          </a>
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button-mobile"
            className="sm:hidden inline-flex items-center gap-2 bg-[#FF4500] text-white px-3 py-2.5 font-display font-bold text-xs"
          >
            <PhoneCall className="w-4 h-4" strokeWidth={2.5} />
            Call
          </a>

          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden ml-1 p-2 text-zinc-900"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile nav drawer */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-zinc-200 bg-white"
        >
          <nav className="flex flex-col px-6 py-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-3 font-display font-semibold text-zinc-800 border-b border-zinc-100 last:border-0"
              >
                {n.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
